
export const COP_UA_DEFAULTS = {

    SWITCH_ACCOUNT_TITLE: 'Select an Account',

    DESCRIPTION: 'Please select an account from the list',

    ACCOUNT_DROPDOWN_PLACEHOLDER: 'Select account',

    SEARCH_PLACEHOLDER: 'Search accounts…',

    CONFIRM_BUTTON_LABEL: 'Confirm Selection',

    CONFIRM_BUTTON_URL: '/content/powerportal/language-masters/en/home.html',

    CANCEL_BUTTON_LABEL: 'Cancel',

    CANCEL_BUTTON_URL: '#',

    ALTERNATIVE_ACCESS_TEXT: 'OR directly enter:',

    ADMIN_BUTTON_LABEL: 'Administration Mode',

    ADMIN_BUTTON_URL: '#',

    API_ERROR_MESSAGE: 'Unable to load accounts. Please try again later.',
} as const
